<template>
  <div class="nuttrema-hi-john">
    <h1 v-html="_markdown.renderInline($t('label.hi_john_welcome_back', { name: $auth.user().first_name }))"></h1>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-hi-john',
};
</script>

<style lang="scss">
  .nuttrema-hi-john {
    h1 {
      margin: 1em;
      color: #fff;
      font-weight: 300;
      font-size: 3.5rem;
      text-align: center;
      font-family: 'Asap';
      line-height: 4.5rem;
    }
    span {
      font-weight: 800;
    }

    .nuttrema-theme-professional-topography & {
      h1, span {
        color: #465568;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/label/nuttrema-hi-john.vue